import React from 'react';
import './index.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpRightDots,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import QuantityChangeButton from '../../../components/QuantityChangeButton';
import ButtonComponent from '../../../components/ButtonComponent';
import { getImageUrlWithFallback } from '../../../utility/Utility';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { MenuItem } from '../../Home';
import { useGetMenuCustomListFromCustomerSiteQuery, useGetMenuSetListFromCustomerSiteQuery, useGetMenuSingleListFromCustomerSiteQuery } from '../../../redux/services/setMenuService';
import { RESTAURANT_ID } from '../../../constants/constans';
import defaultImage from "../../../assets/images/Defult.PNG";
import { initialData } from "../../../redux/services/initialDataService";
import { useSelector } from 'react-redux';

const SignatureDishes = () => {
  const navigate = useNavigate();

  const restaurantId = RESTAURANT_ID;

  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // const { data: initialData } =
  //   useGetInitialDataQuery(undefined, { skip: !isAuthenticated });
  const initialData: initialData = useSelector(
    (state: any) => state.initialData
  );

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <button className="custom-next" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
    </button>
  );

  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <button className="custom-prev" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronLeft} className="arrow-icon" />
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1340,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 510,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleCartList = () => {
    navigate("/shoppingCart");
  };

  const { data: singleMenuData } =
    useGetMenuSingleListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: setMenuData } =
    useGetMenuSetListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: customMenuData } =
    useGetMenuCustomListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const findDishDetails = (id: string, itemType: string) => {
    switch (itemType) {
      case "MenuItem":
        return singleMenuData?.menusItems?.find(
          (item: MenuItem) => item.itemId === id
        );
      case "setMenu":
        return setMenuData?.setMenus?.find(
          (item: MenuItem) => item.itemId === id
        );
      case "customMenu":
        return customMenuData?.customMenus?.find(
          (item: MenuItem) => item.itemId === id
        );
      default:
        return null;
    }
  };

  return (
    <div className="signature-dishes-container">
      <h1>Signature Dishes</h1>
      <p className="signature-dishes-container-description">
        Every dish at Curry King tells a story of heritage and passion.
        Our signature rice and curry meals are expertly crafted by our
        chefs to be nutritionally balanced, delicious, and full of
        authentic Sri Lankan flavor — a true must-try for any food lover.
      </p>
      {authLoading ? (
        <div className="signature-dishes-loading text-center py-5">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">
              Loading Signature Dishes...
            </span>
          </div>
        </div>
      ) : (
        <Slider {...settings}>
          {initialData?.home?.signatureDishes.map((dish) => {
            // Get the full dish details based on itemType
            const fullDish = findDishDetails(dish.id, dish.itemType);

            if (!fullDish) return null; // Skip if dish not found

            return (
              <div className="dish-card" key={fullDish.id}>
                <img
                  src={getImageUrlWithFallback(fullDish.imageUrl, defaultImage, 256)}
                  alt={fullDish.displayName}
                  className="dish-card-img"
                />
                <h3>{fullDish.displayName}</h3>
                <div className="price-container">
                  <span>Product Id: {fullDish.productId}</span>
                  <span>LKR: {fullDish.price}</span>
                </div>

                <p className="dish-card-description">
                  {fullDish.description}
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <QuantityChangeButton
                    id={fullDish.id}
                    name={fullDish.displayName}
                    price={Number(fullDish.price)}
                    description={fullDish.description}
                    imageUrl={fullDish.imageUrl}
                    portionName={""}
                    additionalCost={0}
                  />
                  <ButtonComponent
                    title="Order Now"
                    icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                    backgroundColor="#FF1001"
                    onClick={handleCartList}
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      )}
    </div>
  );
};

export default SignatureDishes;
